import { render, staticRenderFns } from "./AdminDelete.vue?vue&type=template&id=68d3cc8e&scoped=true&"
import script from "./AdminDelete.vue?vue&type=script&lang=js&"
export * from "./AdminDelete.vue?vue&type=script&lang=js&"
import style0 from "./AdminDelete.vue?vue&type=style&index=0&id=68d3cc8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d3cc8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
